import React,{ useState } from 'react';
import $ from 'jquery';

const Compiler = () =>{
      
      const [state,setState] = useState({
        lyrics:""
      })
      const textAreaRef = React.createRef
      const onChange = event => {
        setState({
          lyrics: event.target.value
        });
      };

      // const [input,setInput] = useState([])
      // const [expectedOutput, setExpectedOutput] = useState([])

      
      
      
    
      const onKeyDown = event => {
        if (event.keyCode === 9) {          
          event.preventDefault();    
          const { selectionStart, selectionEnd } = event.target;
          setState(
            prevState => ({
              lyrics:
                prevState.lyrics.substring(0, selectionStart) +
                "\t" + // '\t' = tab, size can be change by CSS
                prevState.lyrics.substring(selectionEnd)
            }),
            () => {
              textAreaRef.current.selectionStart = textAreaRef.current.selectionEnd =
                selectionStart + 1;
            }
          );
        }
      };

      const API_KEY = "15f6434971msh928491e43f03395p19e452jsnaf224fda749e"; // Get yours for free at https://rapidapi.com/hermanzdosilovic/api/judge0
      var language_to_id = {
        "Bash": 46,
        "C": 50,
        "C#": 51,
        "C++": 54,
        "Java": 62,
        "Python": 71,
        "Ruby": 72
    };
    function encode(str) {
      return btoa(unescape(encodeURIComponent(str || "")));
  }

  function decode(bytes) {
      var escaped = escape(atob(bytes || ""));
      try {
          return decodeURIComponent(escaped);
      } catch {
          return unescape(escaped);
      }
  }

  function errorHandler(jqXHR, textStatus, errorThrown) {
      $("#output").val(`${JSON.stringify(jqXHR, null, 4)}`);
      $("#run").prop("disabled", false);
  }

  function check(token) {
      $("#output").val($("#output").val() + "\nChecking submission status...");
      $.ajax({
          url: `https://judge0-ce.p.rapidapi.com/submissions/${token}?base64_encoded=true`,
          type: "GET",
          headers: {
              "x-rapidapi-host": "judge0-ce.p.rapidapi.com",
            "x-rapidapi-key": API_KEY
          },
          success: function (data, textStatus, jqXHR) {
              if ([1, 2].includes(data["status"]["id"])) {
                  $("#output").val($("#output").val() + "\nStatus: " + data["status"]["description"]);
                  setTimeout(function() { check(token) }, 1000);
              }
              else {
                  var output = [decode(data["compile_output"]), decode(data["stdout"])].join("\n").trim();
                  console.log(output,$("#output1").val());
                  if(output === $("#output1").val()){
                    console.log("Accepted");
                  }
                  $("#output").val(output);
                  $("#run").prop("disabled", false);
              }
          },
          error: errorHandler
      });
      
  }

  function run() {
      
      $("#run").prop("disabled", true);
      $("#output").val("Creating submission...");
      console.log(typeof($("#input").val()[0]),$("#input").val()[1]);
      
      $.ajax({
          url: "https://judge0-ce.p.rapidapi.com/submissions?base64_encoded=true",
          type: "POST",
          contentType: "application/json",
          headers: {
              "x-rapidapi-host": "judge0-ce.p.rapidapi.com",
            "x-rapidapi-key": API_KEY
          },
          data: JSON.stringify({
              "language_id": language_to_id[$("#lang").val()],
              "source_code": encode($("#source").val()),
              "stdin": encode($("#input").val()),
              "redirect_stderr_to_stdout": true
          }),
          success: function(data, textStatus, jqXHR) {
              $("#output").val($("#output").val() + "\nSubmission created.");
              setTimeout(function() { check(data["token"]) }, 1000);
          },
          error: errorHandler
      });
      
  }
    return (
        <>
        <h4>Select Language</h4>
                <select id="lang" style = {{width:"20%",height:"30%"}} className="form-control form-inline language">
                    <option>Bash</option>
                    <option>C#</option>
                    <option selected>C++</option>
                    <option>C</option>
                    <option>Java</option>
                    <option>Python</option>
                    <option>Ruby</option>
                </select>
                <br/>
        <textarea
        ref={textAreaRef}
        style = {{width:"70%",height:"280px"}}
        onKeyDown={onKeyDown}
        value = {state.lyrics}
        onChange={onChange}
        id = "source"
        autoCorrect = "off"
        autoCapitalize = "none"
        spellCheck = "false"
        tabIndex = "0"
        wrap = "off"
        />
        <br />
                    
        <button className = "btn btn-primary" id="run" onClick={run} style = {{width:"20%"}}>Run</button> 
        <button className = "btn btn-success" id="Submit"  style = {{width:"20%",margin:"2%"}}>Submit</button>   
        <br/>
        <br />
        <h4>Input</h4>
        <textarea id="input"></textarea>
        
        
        <br/>
        <textarea readOnly = {true} id="output"></textarea>
        
        <br />


        </>
    )
}

export default Compiler
